import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles({
  mainBody: {
    minWidth: '400px',
    margin: '1em',
  },

  blockName: {
    opacity: '0.54',
  },

  card: {
    margin: '10px 0',
    padding: '10px',
  },

  name: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    paddingBottom: '5px',
  },

  release: {
    marginTop: '10px',
  },

  slug: {},
})
